import { ProjectType } from "../pages/landing-page/Project";
// import bounce from "../assets/projects/bounce.jpg";
import backd from "../assets/projects/backd.jpg";
// import uwucrew from "../assets/projects/uwucrew.jpg";
// import aiko from "../assets/projects/aiko.jpg";
// import waifusion from "../assets/projects/waifusion.jpg";
// import billionaires from "../assets/projects/billionaires.jpg";
import cryptoCapsule from "../assets/projects/crypto-capsule.jpg";
// import killerGF from "../assets/projects/killer-gf.jpg";
import ami from "../assets/projects/ami.jpg";
import state from "../assets/projects/state.jpg";
import sitesoft from "../assets/projects/sitesoft.jpg";
import slingshot from "../assets/projects/slingshot.jpg";
import orcon from "../assets/projects/orcon.jpg";
import reactPhotoStudio from "../assets/projects/react-photo-studio.jpg";
import dateformat from "../assets/projects/dateformat.jpg";
// import debtFarming from "../assets/projects/debt-farming.jpg";
// import akula from "../assets/projects/akula.jpg";
import gummy from "../assets/projects/gummy.jpg";
import tlx from "../assets/projects/tlx.jpg";
import synthetix from "../assets/projects/synthetix.jpg";
import pokemonJs from "../assets/projects/pokemon-js.jpg";
import skittles from "../assets/projects/skittles.jpg";
import coinCaster from "../assets/projects/coin-caster.jpg";
import pocketCardsApi from "../assets/projects/pocket-cards.jpg";
import aiHedgeFund from "../assets/projects/ai-hedge-fund.jpg";
import openDogRegistry from "../assets/projects/open-dog-registry.jpg";
import darkly from "../assets/projects/darkly.jpg";
import dogmatch from "../assets/projects/dogmatch.jpg";
import bnzBankBuddy from "../assets/projects/bank-buddy.jpg";
import pocketTierList from "../assets/projects/pocket-tier-list.jpg";

export interface TabType {
  label: string;
  projects: ProjectType[];
}

const portfolioTabs: TabType[] = [
  {
    label: "DeFi",
    projects: [
      // {
      //   name: "Bounce Tech",
      //   description:
      //     "Bounce Tech provides leveraged tokens for over 200 assets, including stocks, ETFs, commodities and crypto. Built on top of Hyperliquid",
      //   image: bounce,
      //   link: "https://bounce.tech/",
      // },
      {
        name: "Synthetix",
        description:
          "Synthetix is a non-custodial liquidity protocol enabling trustless perpetuals, leveraged tokens, and tokenized strategies",
        image: synthetix,
        link: "https://synthetix.io/",
      },
      {
        name: "TLX",
        description:
          "TLX provides leveraged tokens for over 50 assets with up to 20x leverage, powered by Synthetix, on the Optimism blockchain",
        image: tlx,
        link: "https://tlx.fi/",
      },
      {
        name: "Mero Finance",
        description:
          "The DeFi protocol for increasing the yield and utility of your crypto assets with reactive liquidity",
        image: backd,
        link: "https://mero.finance/",
      },
      {
        name: "Crypto Capsule",
        description:
          "Crypto Capsule is a tool for creating timelock contracts that can be used as a decentralised term deposit or trust fund",
        image: cryptoCapsule,
        link: "https://blockchain-time-capsule.web.app/",
      },
      // {
      //   name: "Akula",
      //   description:
      //     "Akula is the fastest Ethereum protocol client implementation. It supports Faster sync speeds, crash resilience and a state API",
      //   image: akula,
      //   link: "https://akula-dac7e.web.app/",
      // },
      // {
      //   name: "Debt Farming",
      //   description:
      //     "The best DeFi yields on Ethereum for your favourite crypto assets",
      //   image: debtFarming,
      //   link: "https://debtfarming.com/",
      // },
    ],
  },
  {
    label: "Work",
    projects: [
      {
        name: "State Insurance",
        description:
          "State Insurance protects over 400,000 New Zealanders. Recipient of Reader's Digest Trusted Brand Award",
        image: state,
        link: "https://business.state.co.nz/",
      },
      {
        name: "AMI Insurance",
        description:
          "AMI is one of New Zealand's most trusted insurers, receiving the trusted Brand award for eight years running",
        image: ami,
        link: "https://business.ami.co.nz/",
      },
      {
        name: "Site Connect",
        description:
          "New Zealand's leading site management & health and safety system for construction and property management",
        image: sitesoft,
        link: "https://sitesoft.com/",
      },
      {
        name: "Orcon Power",
        description:
          "Orcon is a New Zealand telecommunications provider offering broadband, power and mobile plans",
        image: orcon,
        link: "https://www.orcon.net.nz/power",
      },
      {
        name: "Slingshot Power",
        description:
          "Slingshot is the fourth largest telecommunications company in New Zealand that bundles power into a single plan",
        image: slingshot,
        link: "https://www.slingshot.co.nz/power",
      },
    ],
  },
  {
    label: "Fun",
    projects: [
      {
        name: "Pokemon JS",
        description:
          "Browser based React + TypeScript remake of Pokémon Red/Blue",
        image: pokemonJs,
        link: "https://github.com/chase-manning/pokemon-js",
      },
      {
        name: "Dogmatch",
        description:
          "Dogmatch finds your ideal dog from 200+ breeds via a quiz",
        image: dogmatch,
        link: "https://github.com/chase-manning/dogmatch",
      },
      {
        name: "BNZ Bank Buddy",
        description:
          "A Chrome Extension to add some useful features to the BNZ Bank website",
        image: bnzBankBuddy,
        link: "https://github.com/chase-manning/bnz-bank-buddy",
      },
      {
        name: "Coin Caster",
        description:
          "Coin Caster is a Raycast extension delivering real-time crypto prices, charts, and watchlists for thousands of tokens",
        image: coinCaster,
        link: "https://github.com/chase-manning/coin-caster",
      },
      {
        name: "Darkly",
        description: "A Chrome extension to add dark mode to any website",
        image: darkly,
        link: "https://github.com/chase-manning/darkly",
      },
      {
        name: "React Photo Studio",
        description:
          "React Photo Studio is a free online photo editor for photography and design",
        image: reactPhotoStudio,
        link: "https://github.com/chase-manning/react-photo-studio",
      },
      {
        name: "Pocket Tier List",
        description:
          "Tier-list app ranking Pokémon TCG Pocket decks from live tournament stats",
        image: pocketTierList,
        link: "https://github.com/chase-manning/pokemon-tcg-pocket-tier-list",
      },
      {
        name: "Gummy Dashboard",
        description:
          "A simple and free dashboard for displaying your favourite sites using iframes",
        image: gummy,
        link: "https://github.com/chase-manning/gummy-dashboard",
      },
    ],
  },
  {
    label: "Techy",
    projects: [
      {
        name: "Skittles",
        description:
          "Skittles is a TypeScript-to-EVM compiler letting devs write Ethereum smart contracts in TypeScript",
        image: skittles,
        link: "https://github.com/chase-manning/skittles",
      },
      {
        name: "AI Hedge Fund",
        description:
          "AI Hedge Fund autonomous agents analyze market data and coordinate algorithmic stock trades",
        image: aiHedgeFund,
        link: "https://github.com/chase-manning/ai-hedge-fund",
      },
      {
        name: "Dateformat",
        description:
          "The fastest, and most popular javascript date formatting library on npm",
        image: dateformat,
        link: "https://github.com/felixge/node-dateformat",
      },
      {
        name: "Open Dog Registry",
        description:
          "Open Dog Registry is a free open-source API of detailed dog breed data",
        image: openDogRegistry,
        link: "https://registry.dog/",
      },
      {
        name: "Pocket Cards API",
        description:
          "Open-source, auto-updated JSON repository of Pokémon TCG Pocket card data",
        image: pocketCardsApi,
        link: "https://github.com/chase-manning/pokemon-tcg-pocket-cards",
      },
    ],
  },
  // {
  //   label: "NFTs",
  //   projects: [
  //     {
  //       name: "Killer GF",
  //       description:
  //         "An anime art NFT collection on Ethereum, featuring cute girlfriends that are also killer assassins. Art by ex-Riot Games artist Zeronis",
  //       image: killerGF,
  //       link: "https://killergf.com/",
  //     },
  //     {
  //       name: "Aiko Virtual",
  //       description:
  //         "A collection of 8,888 NFTs that are all about 'Cyber Cute', an aesthetic that blends future tech with anime",
  //       image: aiko,
  //       link: "https://aikovirtual.com/",
  //     },
  //     {
  //       name: "Bitcoin Billionaires",
  //       description:
  //         "A collection of unique pixel art NFTs from the creators of Bitcoin Billionaire, the hit mobile game with over 10 million downloads",
  //       image: billionaires,
  //       link: "https://billionaires.io/",
  //     },
  //     {
  //       name: "Uwucrew",
  //       description:
  //         "uwucrew is a generative collection of 9,670 avatar NFTs inspired by anime and pop culture",
  //       image: uwucrew,
  //       link: "https://uwucrew.art/",
  //     },
  //     {
  //       name: "Waifusion",
  //       description:
  //         "Waifusion is a set of 16,384 uniquely generated, anime inspired, digital waifu NFT collectibles on Ethereum and Binance Smart Chain",
  //       image: waifusion,
  //       link: "https://waifusion.io/",
  //     },
  //   ],
  // },
];

export default portfolioTabs;
